// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ka-0";
export var discountCodeInput = "_ka-1";